import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomCol, FormLabels, CustomFileInput } from 'src/components'

const BrokerageInvoiceDocumentField: React.FC<any> = (onResetFile: boolean) => {
  const { t } = useTranslation()

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.InvoiceDocument')}
        subtitle={t('general.RequiredField')}
      />
    </CustomCol>
    <CustomCol>
      <CustomFileInput
        name='invoiceDocument'
        showFileIcon={true}
        returnFile={true}
        onResetFile={onResetFile}
        required
      />
    </CustomCol>
  </Row>
}

export default BrokerageInvoiceDocumentField
